module.exports = __webpack_public_path__ + "static/Charter-Bold-28752e29a71d16fb1571da41f5fbf977.ttf";